<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="5" :sm="24">
            <a-form-item label="时间">
              <a-date-picker @change="onChange" v-model="clearDate"></a-date-picker>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="项目">
              <a-select
                style="max-width: 200px;min-width: 100%"
                showSearch
                :disabled="showable"
                placeholder="请选择"
                v-decorator="['projectId', {rules: [{required: true, message: '请选择项目'}]}]"
                :options="projectList"
                v-model="queryParam.projectId"
                optionFilterProp="children"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() =>{ queryParam = {},clearDate = undefined, queryParam.dailyType= 'build'}" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button @click="create" icon="plus" type="primary" v-action="'dailyBuild:dailyBuildView:add'">新建</a-button>
    </div>
    <s-table
      bordered
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.id"
    >
      <span slot="action" slot-scope="text,record">
        <div>
          <span v-action="'dailyBuild:dailyBuildView:show'">
            <a @click="show(record)">详情</a>
          </span>
          <span v-action="'dailyBuild:dailyBuildView:edit'" v-if="record.state ==='0' || record.state ==='2'|| $auth('dailyBuild:dailyBuildView:admin')">
            <a-divider type="vertical" />
            <a @click="edit(record)">修改</a>
          </span>
          <span v-action="'dailyBuild:dailyBuildView:del'">
            <a-divider type="vertical" />
            <a-popconfirm title="是否删除" @confirm="deleteItem(record)" okText="是" cancelText="否">
              <a-icon slot="icon" type="question-circle-o" style="color: red" />
              <a href="javascript:;" style="color: red">删除</a>
            </a-popconfirm>
          </span>
          <span v-action="'dailyBuild:dailyBuildView:calculation'">
            <a-divider type="vertical" />
            <a-popconfirm title="是否重置计算" @confirm="resetSum(record)" okText="是" cancelText="否">
              <a-icon slot="icon" type="question-circle-o" style="color: #ff0000" />
              <a href="javascript:;" style="color: red">计算</a>
            </a-popconfirm>
          </span>
        </div>
      </span>
    </s-table>
  </a-card>
</template>

<script>
import moment from 'moment'
import { TableMixin } from '@/mixins/TableMixin'
import { dropProjectByType } from '@/api/project/ProjectInfo'
import { fetchList, delect, resetSumByDaily } from '@/api/daily/DailyInfo'
import { enterEvent } from '@/utils/util'
import { Ellipsis } from '@/components'

const stateList = [
  {
    label: '未提交',
    status: 'default',
    value: '0'
  },
  {
    label: '审核中',
    status: 'processing',
    value: '1'
  },
  {
    label: '已驳回',
    status: 'error',
    value: '2'
  },
  {
    label: '通过',
    status: 'success',
    value: '3'
  }
]
export default {
  name: 'DailyBuildView',
  mixins: [TableMixin],
  components: {
    Ellipsis
  },
  data () {
    return {
      showable: false,
      dailyInfoState: '',
      clearDate: undefined,
      dateFormat: 'YYYY/MM/DD',
      projectList: [],
      queryParam: {
        projectId: undefined,
        dailyType: 'build',
        date: undefined
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      },
      columns: [
        {
          title: '序号',
          width: '65px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '项目名称',
          dataIndex: 'projectName',
          customRender: (text) => {
            return (
              <ellipsis length={60} tooltip>{text}</ellipsis>
            )
          }
        },
        {
          title: '日期',
          width: '150px',
          dataIndex: 'dailyDate',
          customRender: (text) => {
            return (
              <div>
                { moment(text).format('YYYY-MM-DD')}
              </div>
            )
          }
        },
        {
          title: '状态',
          dataIndex: 'state',
          width: '150px',
          customRender: (record) => {
            return (
              <div>
                {
                  stateList.map(item => {
                    if (item.value === record) {
                      return <a-badge status={item.status} text={item.label} />
                    }
                  })
                }
              </div>
            )
          }
        },
        {
          title: '操作',
          width: '200px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  methods: {
    init () {
      dropProjectByType('build').then(res => {
        this.projectList = res.data
      })
    },
    create () {
      this.$router.push({ name: 'dailyBuildAdd', query: { id: null, type: 'add' } })
    },
    show (record) {
      const id = record.id
      const state = record.state
      this.$router.push({ name: 'dailyBuildAdd', query: { id: id, type: 'show', state: state } })
    },
    edit (record) {
      const id = record.id
      const state = record.state
      this.$router.push({ name: 'dailyBuildAdd', query: { id: id, type: 'edit', state: state } })
    },
    deleteItem (record) {
      delect(record).then(res => {
        this.queryPage()
      })
    },
    // 重置计算
    resetSum (record) {
      this.$message.info('过程较长请等待1分钟！')
      resetSumByDaily(record.id).then(res => {
        this.queryPage()
        this.$message.success('重置计算操作成功！')
      })
    },
    onChange (date, dateString) {
      // 格式化日期类
      if (date !== null) {
        // this.queryParam.dailyDate = date.format('YYYY-MM-DD HH:mm:ss')
        this.queryParam.dailyDate = moment(date).format('YYYY-MM-DD')
      } else {
        this.queryParam.dailyDate = undefined
      }
    }
  },
  created () {
    this.init()
    enterEvent(this.queryPage)
  },
  activated () {
    this.init()
    this.queryPage()
  }
}
</script>

<style scoped>

</style>
